import Styles from './style.module.scss'

export default function DNone () {
  return (
    <div className={Styles.container}/>
  )
}